import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AlertsPageModule } from './alerts/alerts.module';
import { HomePageModule } from './home/home.module';

const routes: Routes = [
  {
    loadChildren: () => HomePageModule,
    path: ''
  },
  {
    loadChildren: () => AlertsPageModule,
    path: 'alerts'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class PropertyPageRoutingModule {}
